import { Box, FormControl, FormHelperText, Typography } from '@mui/material'
import { FormInput, FormTextArea } from '../../../../../shared/styles/HelpCenterStyles'
import { ContactFormFieldProps } from '../../../models/helpcenter'

const ContactFormField = ({
  label,
  placeholder,
  value,
  onChange,
  error,
  helperText,
  secondaryHelperText,
  ariaLabel,
  multiline = false,
  rows = 1
}: ContactFormFieldProps) => {
  const InputComponent = multiline ? FormTextArea : FormInput

  return (
    <>
      <Box mb={0.5}>
        <Typography>{label}</Typography>
      </Box>
      <FormControl fullWidth>
        <InputComponent
          placeholder={placeholder}
          onChange={onChange}
          error={error}
          value={value}
          fullWidth
          variant="outlined"
          multiline={multiline}
          rows={rows}
          inputProps={{
            'aria-label': ariaLabel
          }}
        />
        {secondaryHelperText && <FormHelperText>{secondaryHelperText}</FormHelperText>}
        <FormHelperText error id={`${ariaLabel}-helper-text`}>
          {helperText}
        </FormHelperText>
      </FormControl>
    </>
  )
}

export default ContactFormField
